import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Toast from "../components/Toast";
import { SHA256 } from "crypto-js";

import { db } from "../utils/firebase";
import { onValue, ref, push } from "firebase/database";

import { useNavigate } from "react-router-dom";

const SignupPage = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");

  const [userData, setUserData] = useState([]);

  const [showErrorToast, setShowErrorToast] = useState(false);
  const [errMessage, setErrMessage] = useState("");

  useEffect(() => {
    const dataRef = ref(db, "userdata");

    onValue(dataRef, (snapshot) => {
      const dataVal = snapshot.val();

      if (dataVal) {
        setUserData(Object.values(dataVal));
      }
    });
  }, []);

  const handleError = () => {
    setShowErrorToast(true);

    setTimeout(() => {
      setShowErrorToast(false);
    }, 3000);
  };

  const submit = async () => {
    if (name && email && pass) {
      const result = userData.filter((user) =>
        user.name.toLowerCase().includes(name.toLowerCase()),
      );

      if (result.length > 0) {
        setErrMessage("User already exists!");
        handleError();
      } else {
        let hashValue = await SHA256(pass).toString();

        const user = {
          name: name,
          email: email,
          pass: hashValue,
        };

        try {
          await push(ref(db, "userdata"), user);

          localStorage.setItem("username", name);

          navigate("/page");
        } catch (error) {
          console.error("Error adding data: ", error);
        }
      }
    } else {
      setErrMessage("Please fill all details!");
      handleError();
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F7FB] relative overflow-hidden">
      <Header btn="Login" path={"/login"} />

      {/* Background Blur */}
      <div className="absolute top-[-120px] left-[-120px] w-[260px] h-[260px] bg-[#4F46E5]/10 rounded-full blur-3xl"></div>

      <div className="absolute bottom-[-120px] right-[-120px] w-[260px] h-[260px] bg-[#14B8A6]/10 rounded-full blur-3xl"></div>

      {/* Main Section */}
      <div className="relative z-10 flex items-center justify-center min-h-[84vh] px-6 pt-[82px] pb-4">
        <div className="w-full max-w-2xl bg-white/85 backdrop-blur-xl rounded-[24px] shadow-[0_10px_40px_rgba(0,0,0,0.06)] border border-white px-8 py-7 sm:px-10 sm:py-8">
          {/* Heading */}
          <div className="text-center">
            <h1 className="text-2xl font-black text-gray-800 tracking-tight">
              Create Account
            </h1>

            <p className="mt-2 text-gray-500 text-sm">
              Sign up to continue to CheXCare
            </p>
          </div>

          {/* Form */}
          <div className="mt-7 grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Name */}
            <div>
              <label className="text-sm font-semibold text-gray-700">
                Full Name
              </label>

              <input
                type="text"
                placeholder="Enter your name"
                onChange={(e) => setName(e.target.value)}
                className="mt-2 w-full h-[46px] rounded-xl border border-gray-200 bg-gray-50 px-4 outline-none focus:border-[#4F46E5] focus:bg-white transition-all duration-300"
              />
            </div>

            {/* Email */}
            <div>
              <label className="text-sm font-semibold text-gray-700">
                Email Address
              </label>

              <input
                type="email"
                placeholder="Enter your email"
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full h-[46px] rounded-xl border border-gray-200 bg-gray-50 px-4 outline-none focus:border-[#4F46E5] focus:bg-white transition-all duration-300"
              />
            </div>

            {/* Password */}
            <div className="md:col-span-2">
              <label className="text-sm font-semibold text-gray-700">
                Password
              </label>

              <input
                type="password"
                placeholder="Enter your password"
                onChange={(e) => setPass(e.target.value)}
                className="mt-2 w-full h-[46px] rounded-xl border border-gray-200 bg-gray-50 px-4 outline-none focus:border-[#4F46E5] focus:bg-white transition-all duration-300"
              />
            </div>
          </div>

          {/* Button */}
          <button
            onClick={() => submit()}
            className="w-full mt-6 h-[48px] rounded-xl bg-gradient-to-r from-[#4F46E5] to-[#6366F1] text-white font-semibold shadow-md hover:shadow-lg hover:scale-[1.01] transition-all duration-300"
          >
            Create Account
          </button>

          {/* Login */}
          <p className="text-center text-sm text-gray-500 mt-5">
            Already have an account?{" "}
            <a
              href="/login"
              className="text-[#4F46E5] font-semibold hover:underline"
            >
              Login
            </a>
          </p>
        </div>
      </div>

      {/* Toast */}
      {showErrorToast && (
        <Toast
          message={errMessage}
          type="error"
          onClose={() => setShowErrorToast(false)}
        />
      )}
    </div>
  );
};

export default SignupPage;
